<template>
  <!-- 根元素添加动态主题类，根据current切换颜色 -->
  <div class="bodyMain" :class="{ 'blue-theme': current === 0, 'green-theme': current === 1 }">
    <div class="tabs fcb">
      <div
        class="tab fccC f1"
        @click="change(index)"
        v-for="(item, index) in tabs"
        :key="index"
        :class="{ choose: current == index }"
      >
        <img class="icon" :src="current == index ? item.icon : item.iconN" alt="" />
        <div class="title">{{ item.label }}</div>
      </div>
    </div>
    <div class="main">
      <div class="tip fcc">
        <img src="./assets/zfb/wait.png" alt="" />
        <div class="">预计此项花费 1~2 分钟</div>
      </div>
      <div class="content">
        <div class="once" v-for="(item, index) in useContent" :key="index">
          <div class="name"><i class="el-icon-success"></i>{{ item.name }}</div>
          <div class="mainC" v-for="(stem, sndex) in item.msgList || []" :key="sndex">
            <div class="msg" v-if="stem.msg">{{ stem.msg }}</div>
            <div class="imgs" v-if="stem.imgs">
              <div class="" v-for="(gtem, gndex) in stem.imgs" :key="gndex">
                <div class="">{{ gtem.t }}</div>
                <el-image
                  v-if="!gtem.t"
                  :src="gtem.m || gtem"
                  style="width: 80px; height: 80px;margin-right: 4px;"
                  :style="{ width: gtem.sw }"
                  alt=""
                  :preview-src-list="srcList"
                />
              </div>
            </div>
            <div class="msgs" :class="{ blueBox: stem.blueBox }" v-if="stem.msgs">
              <span alt="" v-for="(mtem, mndex) in stem.msgs" :key="mndex">
                <span v-if="mtem.t" class="t">{{ mtem.t }}</span>
                <span v-if="mtem.r1" class="r1">{{ mtem.r1 }}</span>
                <span v-if="mtem.r2" class="r2">{{ mtem.r2 }}</span>
                <span v-if="mtem.b1" class="b1">{{ mtem.b1 }}</span>
              </span>
            </div>
            <div class="times" v-if="stem.times">
              <div class="title">{{ stem.times.name }}</div>
              <div class="begin">
                <span class="t">起始时间</span>{{ stem.times.begin }}
              </div>
              <div class="end"><span class="t">结束时间</span>{{ stem.times.end }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="xy">
        <img src="./assets/r.png" class="rpng" alt="" /> 我已阅读并同意
        <span class="" @click="openDoalog(0)">《个人信息授权书》</span>
        <span class="" @click="openDoalog(1)">《用户协议》</span>
        <span class="" @click="openDoalog(2)">《隐私协议》</span>
      </div>
    </div>
    <div class="flotN">
      <div class="fTip">
        <div class="fleft">
          <div class="fs">发送至邮箱</div>
          <div class="fv">aoe@zbcai.cn</div>
        </div>
        <div>
          <div class="fright">复制并前往</div>
        </div>
      </div>
      <div class="fbut">
        <el-button type="primary" round @click="chaangeLabel">{{ useButLabel }}</el-button>
      </div>
    </div>
    <div class="flot">
      <div class="fTip">
        <div class="fleft">
          <div class="fs">发送至邮箱</div>
          <div class="fv">aoe@zbcai.cn</div>
        </div>
        <div>
          <div class="fright">复制并前往</div>
        </div>
      </div>
      <div class="fbut">
        <el-button type="primary" round @click="chaangeLabel">{{ useButLabel }}</el-button>
      </div>
    </div>
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="90%"
      style="border-radius: 10px; height: 100vh; overflow: auto"
      center
      custom-class="doLog"
      :show-close="false"
    >
      <div class="dMian" v-html="usePop"></div>
      <div class="close">
        <el-button @click="centerDialogVisible = false" type="primary">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 脚本部分完全不变
import zfbPng from "./assets/zfb/zfb.png";
import zfbnPng from "./assets/zfb/zfbn.png";
import wxPng from "./assets/wx/wx.png";
import wxnPng from "./assets/wx/wxn.png";

import zfb1 from "./assets/zfb/zfb_1.png";
import zfb2 from "./assets/zfb/zfb_2.png";
import zfb3 from "./assets/zfb/zfb_3.png";
import zfb4 from "./assets/zfb/zfb_4.png";
import zfb5 from "./assets/zfb/zfb_5.png";
import zfb6 from "./assets/zfb/zfb_6.png";

import wx1 from "./assets/wx/w1_1.png";
import wx2 from "./assets/wx/w1_2.png";
import wx3 from "./assets/wx/w1_3.png";
import wx4 from "./assets/wx/w1_4.png";
import wx5 from "./assets/wx/w1_5.png";
import wx6 from "./assets/wx/w1_6.png";
import wx7 from "./assets/wx/w1_7.png";
import wx8 from "./assets/wx/w1_8.png";

import { grxxsqs, yhxy, ysxy } from "./data";
export default {
  data() {
    return {
      centerDialogVisible: false,
      tabs: [
        { label: "支付宝账单", icon: zfbPng, iconN: zfbnPng },
        { label: "微信账单", icon: wxPng, iconN: wxnPng },
      ],
      current: 0,
      grxxsqs,
      yhxy,
      ysxy,
      use: 0,
      zfb: [
        {
          name: "找账单",
          msgList: [
            { msg: "进入支付宝->我->账单->右上角···->点击“开具流水交易证明”" },
            { imgs: [zfb1, zfb2, zfb3] },
          ],
        },
        {
          name: "下载账单",
          msgList: [
            {
              msgs: [
                { r1: "用作材料证明" },
                { r2: "（一定此项）" },
                { t: "->点击全部交易->自定义时间范围选择近12个月->发送至邮箱" },
                { b1: "aoe@zbcai.cn" },
              ],
            },
            {
              times: {
                name: "时间选择示例（范围12个月！）:",
                begin: "2025年11月16日",
                end: "2024年11月17日",
              },
            },
            { imgs: [zfb4, zfb5, zfb6] },
          ],
        },
      ],
      wx: [
        {
          name: "找账单",
          msgList: [
            { msg: "进入微信->我->服务->钱包->客服中心" },
            { imgs: [wx1, wx2, wx3] },
          ],
        },
        {
          name: "下载账单",
          msgList: [
            {
              msgs: [
                { t: "下载账单->" },
                { r1: "用作材料证明" },
                { r2: "（一定此项）" },
              ],
            },
            { imgs: [wx4, wx5] },
            {
              blueBox: true,
              msgs: [
                { t: "选择接收方式为" },
                { r1: "邮箱" },
                { t: "->点击自定义时间选择12个月->发送至邮箱" },
                { b1: "aoe@zbcai.cn" },
              ],
            },
            {
              times: {
                name: "时间选择示例（范围12个月！）:",
                begin: "2025年11月16日",
                end: "2024年11月17日",
              },
            },
            { imgs: [wx7, { t: "或" }, { m: wx8, sw: "160px" }] },
          ],
        },
      ],
    };
  },
  computed: {
    useContent() { return this.current == 0 ? this.zfb : this.wx; },
    useButLabel() { return this.current == 0 ? "我已完成，去微信账单" : "我已完成"; },
    usePop() { return this.use == 0 ? this.grxxsqs : this.use == 1 ? this.yhxy : this.ysxy; },
    srcList() {
      let src = [];
      for (let k in this.useContent) {
        if (this.useContent[k].msgList) {
          for (let s in this.useContent[k].msgList) {
            if (this.useContent[k].msgList[s].imgs) {
              for (let m in this.useContent[k].msgList[s].imgs) {
                if (!this.useContent[k].msgList[s].imgs[m].t) {
                  src.push(this.useContent[k].msgList[s].imgs[m].m || this.useContent[k].msgList[s].imgs[m]);
                }
              }
            }
          }
        }
      }
      return src;
    },
  },
  methods: {
    change(i) { this.current = i; },
    openDoalog(i) { this.use = i; this.centerDialogVisible = true; },
    chaangeLabel() { this.current = this.current == 0 ? 1 : 0; },
  },
};
</script>
<style scoped>
/* 基础布局样式完全不变，仅修复背景色显示问题 */
.fccC { display: flex; align-items: center; justify-content: center; flex-direction: column; }
* { box-sizing: border-box; }
.fcb { display: flex; align-items: center; justify-content: space-between; }
.fcc { display: flex; align-items: center; justify-content: center; }
.f1 { flex: 1; }
.tabs { padding-bottom: 20px; }
.tab {
  color: #fff;
  font-weight: 700;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0.4), hsla(0, 0%, 100%, 0.35));
  padding: 12px;
  margin-right: 12px;
  border-radius: 12px;
  transition: all 0.5s;
  position: relative;
}
.tab::after {
  content: "";
  display: inline-block;
  position: absolute;
  left: 50%;
  bottom: 0;
  border: 0px solid #fff;
  border-top-color: transparent;
  border-left-color: transparent;
  transform: translate(-50%, 50%) rotate(45deg);
  transition: all 0.5s;
}
.tab:first-child { margin-left: 12px; }
.icon { width: 24px; height: 24px; }
.choose { background-color: #fff; }
.choose::after { border: 8px solid #fff; border-top-color: transparent; border-left-color: transparent; }
.main {
  padding: 12px 12px;
  background-color: #fff;
  margin: 0 5%;
  border-radius: 10px;
}
.tip { font-size: 14px; padding: 5px 10px; border-radius: 10px; }
.tip img { width: 18px; height: 18px; }
.name { font-size: 14px; font-weight: 700; }
.msg { font-size: 14px; color: #383838; font-weight: 500; }
.imgs { display: flex; align-items: center; flex-wrap: wrap; }
.imgs imgOnce { width: 80px; height: 80px; margin-right: 8px; }
.t { font-size: 14px; color: #383838; font-weight: 500; }
.r1 { font-size: 14px; color: red; font-weight: 500; }
.r2 { font-size: 10px; color: red; font-weight: 500; }
.b1 { font-size: 14px; font-weight: 500; }
.times {
  border-radius: 10px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  padding: 8px;
}
.times .title { font-size: 14px; color: #383838; padding-bottom: 8px; }
.times .begin, .times .end { height: 30px; font-weight: 700; }
.times .begin .t, .times .end .t { color: #383838; height: 30px; font-weight: 700; }
.times .begin .t::before, .times .end .t::before {
  content: "";
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  margin-right: 8px;
  margin-left: 4px;
}
.mainC > div, .name { margin-top: 8px; }
.rpng { width: 16px; height: 16px; }
.xy { font-size: 12px; font-weight: 400; margin-top: 16px; }
.xy span { cursor: pointer; }
.dMian { overflow: auto; }
:deep(.doLog) {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
  height: calc(100vh - 40px);
  border-radius: 10px;
  overflow-y: auto;
}
:deep(.doLog) .el-dialog__header { display: none; }
:deep(.dMian) img { width: 100%; }
:deep(.dMian) button { display: none; }
.close { position: fixed; bottom: 36px; right: 36px; }
.blueBox { font-size: 14px; padding: 5px 10px; border-radius: 10px; }
.flot {
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 8px;
  border-radius: 8px 8px 0 0;
}
.fTip {
  display: flex;
  align-items: center;
  border-radius: 10px;
  margin: 0 auto 0;
  padding: 0 10px;
  position: relative;
  color: #fff;
}
.fleft { flex: 1; padding: 8px; }
.fbut { display: flex; align-items: center; justify-content: center; margin: 10px 0; }
.fv { font-size: 19px; font-weight: 600; }
.fright {
  font-size: 16px;
  background: linear-gradient(180deg, #f5f7fa, #f5f7fa);
  padding: 3px 12px;
  border-radius: 12px;
}
.flotN {
  position: relative;
  padding-top: 18px;
  opacity: 0;
  user-select: none;
  pointer-events: none;
}
.once { position: relative; padding-left: 8px; }
.once::before {
  content: "";
  display: inline-block;
  width: 1px;
  height: calc(100% - 16px);
  position: absolute;
  left: 0;
  top: 16px;
}
.name { position: relative; padding-left: 8px; }
.el-icon-success {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(-100%, -50%);
}

/* 修复背景色：直接给主题类设置背景，不嵌套 .bodyMain，提高优先级 */
.blue-theme {
  background: linear-gradient(180deg, #6aadfc, #d2e8fd) !important;
  min-height: 100vh;
  padding: 12px 0;
}
.green-theme {
  background: linear-gradient(180deg, #4CAF50, #E8F5E9) !important;
  min-height: 100vh;
  padding: 12px 0;
}

/* 蓝色主题（current=0 支付宝账单） */
.blue-theme .choose { color: #000; }
.blue-theme .tip { background: #edf5ff; }
.blue-theme .name { color: #1c86ff; }
.blue-theme .b1 { color: #268afc; }
.blue-theme .times { background: #edf5ff; }
.blue-theme .times .begin, .blue-theme .times .end { color: #2e84e4; }
.blue-theme .times .begin .t::before, .blue-theme .times .end .t::before { background-color: #2e84e4; }
.blue-theme .xy span { color: #268afc; }
.blue-theme .blueBox { background: #edf5ff; }
.blue-theme .fTip { background: linear-gradient(90deg, #ffa463, #ffc261); }
.blue-theme .fright { color: #268afc; }
.blue-theme .once::before { background-color: #1c86ff; }
.blue-theme .el-icon-success { color: #1c86ff; }
.blue-theme :deep(.el-button--primary) {
  background-color: #1c86ff !important;
  border-color: #1c86ff !important;
}
.blue-theme :deep(.el-button--primary:hover) {
  background-color: #268afc !important;
  border-color: #268afc !important;
}

/* 绿色主题（current=1 微信账单） */
.green-theme .choose { color: #388E3C; }
.green-theme .tip { background: #E8F5E9; }
.green-theme .name { color: #4CAF50; }
.green-theme .b1 { color: #383838; }
.green-theme .times { background: #E8F5E9; }
.green-theme .times .begin, .green-theme .times .end { color: #388E3C; }
.green-theme .times .begin .t::before, .green-theme .times .end .t::before { background-color: #4CAF50; }
.green-theme .xy span { color: #388E3C; }
.green-theme .blueBox { background: #E8F5E9; }
.green-theme .fTip { background: linear-gradient(90deg, #81C784, #4CAF50); }
.green-theme .fright { color: #388E3C; }
.green-theme .once::before { background-color: #4CAF50; }
.green-theme .el-icon-success { color: #4CAF50; }
.green-theme :deep(.el-button--primary) {
  background-color: #4CAF50 !important;
  border-color: #4CAF50 !important;
}
.green-theme :deep(.el-button--primary:hover) {
  background-color: #388E3C !important;
  border-color: #388E3C !important;
}
</style>